// Hooks
import React, { useState, useLayoutEffect } from 'react';
import { Router, RouteComponentProps } from "@reach/router";
import { useSelector, useDispatch } from 'react-redux';

// Modules
import { ReportModal } from './components/report-modal/ReportModal';
import { PositionMap } from './components/devices/map/PositionMap';
import { MainMenu } from './components/menu/mainMenu';
import { Devices } from './components/devices/Devices';
import { SingleDevices } from './components/devices/SingleDevices';

// Store components
import { setUser } from './store/users/userSlice';
import { initAllNodes, initNodes, initSingleNode } from './store/positions/menuNodesSlice';
import { fetchPositions } from './store/positions/positionsSlice';
import { fetchUsers, selectUsers } from './store/users/usersSlice';
import { prepareLivenviroUser, selectUser } from './store/users/userSlice';

// Styled Components
import './Reset.css';
import './App.css';
import styled from 'styled-components';
import { useInterval } from './lib/hooks';

const features = {
  main: {
    menu: false,
    home: true,
    devices: true,
    notifications: true,
    dashboard: true,
    user: true,
  },
  sub: {
    menu: false,
    list: true,
    map: true,
    power: false,
    export: false,
    alarms: false
  }
}

const AppContainer = styled.div`
  width: 100%;
  height: 100%;
  background: #FFF;
  display: flex;
`;

const StyledRouter = styled(Router)`
  height: 100%;
  width: 100%;
`;

type ReportProps = RouteComponentProps & {
  station: any;
  display: boolean;
  site: number;
  report_read_only: boolean;
}

const Reports = (props: ReportProps) => {

  const currentUser = useSelector(selectUser);
  const users = useSelector(selectUsers);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    if(!props.report_read_only){
      console.log('trying to dispatch')
      dispatch(fetchUsers());
    }    
  }, []);

  return (
    <ReportModal users={users} station={props.station} site={props.site} display={props.display} report_read_only={props.report_read_only}/>
  )
}

const StyledHomepage = styled.div`
  width: 100%;
  height: 100%;
`;

const Homepage = (props: RouteComponentProps) => {

  return (
    <StyledHomepage>
      <PositionMap features={features} fullscreen={true} path='/'/>
    </StyledHomepage>
  )
}

const App = () => {

  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  const [station, setStation] = useState({});
  const [site, setSite] = useState(null);
  const [report_read_only, setReportReadOnly] = useState(false);
  
  useLayoutEffect(() => {
    
    if (process.env.REACT_APP_STANDALONE === 'true') {
      dispatch(initNodes())
    }
    // Handle setting User API details and fetching nodes
    window.addEventListener('message', (message) => {
      if (message.data.type === 'INIT_USER') {
        
        // Format user data according to Apps requirement
        const formatted_user = prepareLivenviroUser(message.data.payload);
        
        // Disptach setUser reducer
        dispatch(setUser(formatted_user));
        
        const location = window.location.toString();
        if (location.includes('/singledevices')) {     
          dispatch(initSingleNode())
        }else if (location.includes('/devices')) {          
          dispatch(fetchPositions())
          dispatch(initSingleNode())
        } 
        else if (location.includes('/report')) {
        } 
        else {
          dispatch(initAllNodes())
        }
      }

      if (message.data.type === 'SET_STATION') {
        setStation({ id: message.data.payload.station_id, timezone: message.data.payload.station_timezone })
        setSite(message.data.payload.site_id);
        setReportReadOnly(message.data.payload.report_read_only);
      }
    });

    window.parent.postMessage({ type: 'READY', payload: {} }, "*");

    return () => {
      window.removeEventListener('message', console.log);
    };
  }, []);
  useInterval(() => {
    dispatch(fetchPositions(false));
    // dispatch(fetchPositionSamples(liveSamples[0]));
    // console.log(liveSamples);
    //console.log("Fetching positions");
  }, 60000)
  return (
    <div className="App">
      <AppContainer>
        {features.main.menu? <MainMenu features={features} user={user}/> : null}
        <StyledRouter>
          <Devices features={features} path='devices/*'/>
          {station !== null && site !== null?
          <Reports station={station} site={site} display={true} report_read_only={report_read_only} path='report'/>
          : null}
          <Homepage path='home'/>
          <Devices features={features} path='home'/>
          <SingleDevices path='singledevices/*'/>
        </StyledRouter>
      </AppContainer>
    </div>
  );
}

export default App;
